(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('calendar', {
            parent: 'app',
            url: '/calendar?dateCalendar',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/calendar/calendar.html',
                    controller: 'CalendarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                dateCalendar: moment().format("YYYY-MM-DD")
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('astreinte');
                    $translatePartialLoader.addPart('astreintePlanifie');
                    $translatePartialLoader.addPart('conges');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', function ($stateParams) {
                    return {
                        dateCalendar: $stateParams.dateCalendar
                    }
                }]
            }
        });
    }
})();
